export default __webpack_public_path__ + "static/media/headerRTA.24f97e13.jpg";